// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2TmwQ","notes":"Notes_notes__385ZY","note":"Notes_note__2QtJM","markdown":"Notes_markdown__3GJid"};